
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conversations/[[...slug]]",
      function () {
        return require("private-next-pages/conversations/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conversations/[[...slug]]"])
      });
    }
  